














import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/modals/Modal.vue';
import ModalHeader from '@/components/modals/ModalHeader.vue';
import ModalBody from '@/components/modals/ModalBody.vue';
import CardImage from '@/components/card/CardImage.vue';
import CardInfo from '@/components/card/CardInfo.vue';
import CardPrice from '@/components/card/CardPrice.vue';
import { MODAL, DECKLIST } from '@/store/actions';
import { PokemonTCG } from 'pokemon-tcg-sdk-typescript';

@Component({
  components: {
    Modal,
    ModalHeader,
    ModalBody,
    CardImage,
    CardInfo,
    CardPrice,
  },
})
export default class LoadCardModal extends Vue {
  @Prop() public card!: PokemonTCG.Card;

  private close() {
    if (this.$store.state.modal.closeNormal) {
      this.$router.go(-1);
    } else {
      this.$router.replace('/');
      this.$store.commit(MODAL.SHOW_CARD_INFO, false);
    }
  }
}
